import {createTerrainMaterialPreview,terrainMaterialPreviewRequested} from './terrain-material-preview.js';
/** Release settings adapter. Original is the default; maps load only on explicit opt-in. */
export function mountTerrainMaterialControl(world,{select,status,search='',createPreview=createTerrainMaterialPreview,onController=()=>{}}){
 let preview=null,disposed=false;
 const available=world.mode==='webgl'&&Boolean(world.terrain?.material?.userData.heroUniforms);
 function show(s){
  select.disabled=disposed||!available;select.value=(s.state==='loading'?s.desiredEnabled:s.enabled)?'cc0':'original';
  status.textContent=s.state==='loading'?(s.desiredEnabled?'Loading verified CC0 maps. Original terrain remains active until ready.':'Original terrain selected. CC0 maps are still loading.'):
   s.state==='ready'?(s.enabled?'CC0 rock material is active. Weather controls remain available.':'Original terrain material is active.'):
   s.state==='error'?'CC0 maps could not load. Original terrain remains active. Select CC0 to retry.':
   'Original terrain material is active.';
 }
 function setEnabled(enabled){
  if(disposed)return false;
  if(!available){select.value='original';select.disabled=true;status.textContent='CC0 terrain is unavailable in soft-render mode. Original terrain remains active.';return false;}
  if(preview?.status.state==='error'){preview.dispose();preview=null;onController(null);}
  if(!preview&&!enabled){select.value='original';status.textContent='Original terrain material is active. CC0 maps load only when selected.';return false;}
  try{
   if(!preview){preview=createPreview(world,{enabled:true,onChange:show});onController(preview);preview.ready.catch(()=>{});}
   else preview.setEnabled(enabled);
  }catch(error){select.value='original';select.disabled=true;status.textContent='CC0 terrain is unavailable. Original terrain remains active.';return false;}
  return true;
 }
 const change=()=>setEnabled(select.value==='cc0');select.addEventListener('change',change);
 setEnabled(available&&terrainMaterialPreviewRequested(search));
 return{setEnabled,get preview(){return preview;},get ready(){return preview?.ready??Promise.resolve(null);},dispose(){if(disposed)return;disposed=true;select.removeEventListener('change',change);preview?.dispose();select.disabled=true;}};
}
